import { Skeleton } from '@mui/material';
import { IconType } from 'react-icons';
import classNames from 'classnames';
import { IconButton } from 'app/agriculture/components/Button/Button';
import './ContentBox.scss';
import { HTMLAttributes, ReactNode } from 'react';
import { useFarmPath } from 'app/agriculture/router/useFarmPath';
import { useNavigate } from 'react-router-dom';

interface ContentBoxSkeletonProps {
    title?: string | null;
    Icon?: IconType | null;
    className?: string;
    variant?: 'sm' | 'md' | 'lg' | 'xl';
    children?: ReactNode;
}

// This existing because the normal ContentBox causes cypress to flake out. This seems to be a result of the
// hooks in that component requiring the suspense wrapper and not getting it. This is a version of the content box
// without any hooks - its just layout
export function ContentBoxSkeleton({
    title,
    className,
    Icon,
    children,
    variant = 'sm',
    ...divProps
}: ContentBoxSkeletonProps & HTMLAttributes<HTMLDivElement>) {
    const navigate = useNavigate();
    const farmPath = useFarmPath();

    return (
        <div
            {...divProps}
            className={classNames(
                'ContentBox',
                'display-over-map',
                className,
                `ContentBox--${variant}`,
            )}
        >
            <div className="ContentBox__header">
                {Icon == null ? null : <Icon className="ContentBox__icon" size={18} />}
                {Icon === undefined ? (
                    <Skeleton className="ContentBox__icon" variant="circular" />
                ) : null}
                {title == null ? null : <h5 className="ContentBox__title">{title}</h5>}
                {title === undefined ? (
                    <Skeleton className="ContentBox__title" variant="text" animation="wave" />
                ) : null}

                <IconButton
                    className="ContentBox__close"
                    icon="close"
                    tooltip="Close"
                    onClick={() => {
                        navigate(farmPath('/'));
                    }}
                />
            </div>
            <div className="ContentBox__content">{children}</div>
        </div>
    );
}
